export default pathname => {
  if (!pathname) {
    return null;
  }
  const match = pathname.match(/^\/([a-z]{2}|_)(\/|$)/);
  return match ? match[1] : null;
};
